<script lang="ts">
  import type { Track } from '$lib/models/track';
  import type { User } from '$lib/models/user';
  import type { AssetType } from '$lib/utils/asset';
  import TrackWide from './track-wide.svelte';
  import { player } from '$lib/stores/player';

  export let tracks: Track[];
  export let type: AssetType;
  export let user: User | null | void;
  export let showSimilarIcon = false;
  export let freeMusicModal = false;

  $: player.setQueue(tracks);
</script>

<div class="grid">
  {#each tracks as track, index (track.id)}
    <div class="track-width">
      <TrackWide {track} {type} {user} {showSimilarIcon} {freeMusicModal}/>
    </div>
  {/each}
</div>

<div class="grid"></div>

<style>
  .grid {
    display: flex;
    flex-wrap: wrap;
  }
  .track-width {
    width: 100%;
    border-bottom: 1px solid var(--cultured);
  }
</style>
